import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Form, FormGroup, Label, Card, Col } from "reactstrap";
import { useForm } from "react-hook-form";
import ApiService from "../../../services/apiService";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { updateDistributaryTitle, distributaryZone } from "../../../constants";
import Update from "../../table/Update";

const UpdateBeneficiary =() =>{
    
    const navigate = useNavigate();
    const { Id } = useParams();
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    const [data,setData] = useState<any>();
    const [chackData, setChackData] = useState<any>(null);

    const initialData ={

        
        ChakName:data?.chakName,
        SchemeVillage: data?.schemeVillage,
        Thasil:data?.thasil,
        KhasaraNo:data?.khasaraNo,
        PlotNo:data?.plotNo,
        Kisam:data?.kisam,
        CgaInHa:data?.cgaInHa,
        UnculArea:data?.unculArea,
        CulArea:data?.culArea,
        CcaAcre:data?.ccaAcre,
        NameOfBeneficiary:data?.nameOfBeneficiary
    }

    useEffect(() => {
        const fetchBeneficiary = async () => {
          try {
            const response = await ApiService.axiosApi(`/beneficiarylist/${Id}`, {
              method: 'GET',
            });
    
            if (response.success) {
                console.log(response.data)
              setData(response.data)
            } else {
              toast.error("Failed to fetch distributary details");
              navigate(-1);
            }
          } catch (error: any) {
            toast.error(error.message || "Failed to fetch distributary details");
            navigate(-1);
          }
        };
    
        if (Id) fetchBeneficiary();
      }, [Id, setValue, navigate]);

      useEffect(() => {

        const chack = async () => {
            try {
                const response = await ApiService.axiosApi(`/chack`, {
                    method: "GET",
                    params: {
                        pageNumber: 0,
                        pageSize: 0
                    }
                })
                if (response.success) {
                    
                    setChackData(response.data.data)

                } else {
                    toast.error(response.message || "Failed to fetch chack data");
                }
            } catch (error: any) {
                toast.error(error.message || "Failed to fetch chack data");
            }
        }
        chack();
    }, [])
    
      const onSubmit = async (data: any) => {
        try {
          const updateData = {
            ChakId: data.ChakId,
            SchemeVillage: data.SchemeVillage,
            Thasil:data.Thasil,
            KhasaraNo:data.KhasaraNo,
            PlotNo:data.PlotNo,
            Kisam:data.Kisam,
            CgaInHa:data.CgaInHa,
            UnculArea:data?.UnculArea,
            CulArea:data.CulArea,
            CcaAcre:data.CcaAcre,
            NameOfBeneficiary:data.NameOfBeneficiary

          };
    
            const response = await ApiService.axiosApi(`/beneficiarylist/${Id}`, {
            method: 'PUT',
            data: updateData
          });
    
          if (response.success) {
            toast.success("beneficiary updated successfully");
            navigate(-1);
          } else {
            toast.error(response.data.message || "Failed to update beneficiary");
          }
        } catch (error: any) {
          toast.error(error.message || "Failed to update beneficiary");
        }
      };

      return(

          
             <Update
       title = {'Update Beneficiary '}
       parentTitle={'Beneficiary List'}
       
       fields ={
        [
          
          {
            name : "SchemeVillage",
            label : "Scheme/Village",
            type : "text"
          },
          {
             name:"Thasil",
             label:"Thasil",
             type:"text"
          },
          {
            name:"KhasaraNo",
            label:"KhasaraNo",
            type:"text"
          },
          {
            name:"PlotNo",
            label:"PlotNo",
            type:"text"
          },
          {
            name:"Kisam",
            label:"Kisam",
            type:"text"
          },
          {
            name:"CgaInHa",
            label:"CGA In [Ha]",
            type:"text"
          },
          {
             name:"UnculArea",
             label:"Uncultiv. Area",
             type:"text"
          },
          {
             name:"CulArea",
             label:"Cultiv. Area",
             type:"text"
          },
          {
             name:"CcaAcre",
             label:"C.C.A Acre",
             type:"text"
          },
          {
             name:"NameOfBeneficiary",
             label:"Name Of Beneficiary",
             type:"text"
          },
          {
            name: "ChakName",
            label: "Chak",
            isDropdown: true,
            dropdownData: chackData,
            dropdownLabel: "chackName",
            idFieldName: "chakId"
          }


        ]
       }
       onSubmit = {onSubmit}
       initialData = {initialData}
       />
          
      )
    
}
export default UpdateBeneficiary;